let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jREyT")).then(() => parcelRequire('7txW8'));